<template>

  <div v-if="content" class="tabs-component pt-md-2" id="top">
     <h1
      class="subheadline"
      v-html="content.data.faq.header"
    ></h1>
    <div class="tabs-component-tabs row ">
     <div v-for="(tab, i) in tabs" :key="i" class="col-md-12 qa__links">
        <div class="qa__box qa__box--small" :class="{'first' : i=== 1, 'last': i === tabs.length-1 }"
        v-show="tab.isVisible">
          <router-link
            class="qa__link"
         
            :to="/pytania-i-odpowiedzi/ + tab.index"
            :id="tab.index"
            
          >
            <div v-html="tab.header" class="qa__headline"></div>
            <div class="qa__arrow">
              <img src="@/assets/images/10/arrow_qa.svg" alt="strzałka" />
            </div>
          </router-link>
    </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQ",
  inject: ["content"],
  data() {
    return {
      tabs: this.content.data.faq.accordeon,
      activeTabIndex: 0,
    };
  },

  mounted() {
    this.scrollToTop();
  },

  methods: {
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
